<template>
  <b-card class="rounded-0">
    <h4>{{ title }}
      <b-badge variant="primary" class="ml-2 px-3">{{ items.length }}</b-badge>
      <span class="float-right">
        <b-button size="md"
                  variant="link"
                  class="btn-link"
                  aria-controls="collapseId"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  @click="showCollapse = !showCollapse">
          <span v-if="!showCollapse" class="ti-angle-up"></span>
          <span v-else class="ti-angle-down"></span>
        </b-button>
      </span>
    </h4>
    <b-collapse :id="collapseId" v-model="showCollapse">
      <b-table striped
               responsive
               :fields="fields"
               :items="items"
               tbody-class="text-muted">
        <template slot="actions" slot-scope="row">
          <div class="text-right">
            <b-button size="sm"
                      variant="link"
                      class="btn-link"
                      @click="showDetails(row)">
              <span class="ti-search"></span>
            </b-button>
          </div>
        </template>
      </b-table>
      <div v-if="!items || items.length === 0"
           class="text-center">
        {{ $t('message.adminContractsCard.noItems') }}
      </div>
    </b-collapse>
  </b-card>
</template>
<script>
  export default {
    name: 'ContractsCard',
    props: {
      collapseId: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data () {
      return {
        showCollapse: true,
        fields: [{
          key: 'contractType',
          label: this.$t('message.adminContractsCard.type')
        }, {
          key: 'contractPartner.contractPartnerName',
          label: this.$t('message.adminContractsCard.company')
        }, {
          key: 'contractNumber',
          label: this.items[0].contractType ? this.$t('message.adminContractsCard.insuranceNumber')
            : this.$t('message.adminContractsCard.contractNumber')
        }, {
          key: 'insuredPersonNumber',
          label: this.$t('message.adminContractsCard.insuredPersonNumber')
        }, {
          key: 'conclusionDate',
          label: this.$t('message.adminContractsCard.conclusionDate')
        }, {
          key: 'contractType',
          label: this.$t('message.adminContractsCard.type')
        }, {
          key: 'contractDuration',
          label: this.$t('message.adminContractsCard.contractDuration'),
          formatter: (value) => {
            if (value && value === 1) {
              return this.$t('message.adminContractsCard.time.month', {value: value})
            } else if (value && value > 1) {
              return this.$t('message.adminContractsCard.time.months', {value: value})
            }
            return value
          }
        }, {
          key: 'cancellationPeriod',
          label: this.$t('message.adminContractsCard.cancellationPeriod'),
          formatter: (value) => {
            if (value && value === 1) {
              return this.$t('message.adminContractsCard.time.month', {value: value})
            } else if (value && value > 1) {
              return this.$t('message.adminContractsCard.time.months', {value: value})
            }
            return value
          }
        }, {
          key: 'actions',
          label: ''
        }]
      }
    },
    methods: {
      getCancellationPeriodText (value) {
        if (value && value === 1) {
          return this.$t('message.contractsCard.cancellationPeriod.month', {value: value})
        } else if (value && value > 1) {
          return this.$t('message.contractsCard.cancellationPeriod.months', {value: value})
        }
        return value
      },
      showDetails (row) {
        this.$emit('showDetails', row.item)
      }
    }
  }
</script>
<style scoped>
  .btn-link {
    color: #6c757d;
    text-decoration: none;
  }

  .btn-link:hover {
    color: #21272d;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminContractsCard.vue